import craftProductsCoverImage from '../../../assets/images/craftProducts/craftProductsCoverImage.webp'
import craftProduct1 from '../../../assets/images/craftProducts/brynza-spices-olive-oil-vogni-provansu-pastoral-50-fat-550g.webp'
import craftProduct2 from '../../../assets/images/craftProducts/brynza-herbs-olive-oil-alpiiski-travy-pastoral-50-fat-550g.webp'
import craftProduct3 from '../../../assets/images/craftProducts/brynza-spices-herbs-olive-oil-buket-provansu-pastoral-50-fat-550g.webp'
import craftProductsCoverImageMobile from '../../../assets/images/craftProducts/craftProductsCoverImageMobile.webp'


export const CraftProductsArr = [
    {
        path: "/craft-products/brynza-spices-olive-oil-vogni-provansu-pastoral-50-fat-550g/",
        category: "craft",
        metaTitle: "Бринза зі спеціями в оливковій олії «Вогні Провансу»",
        metaDescription: "Бринза зі спеціями в оливковій олії «Вогні Провансу»",
        coverImage: craftProductsCoverImage,
        coverImageMobile: craftProductsCoverImageMobile,
        coverTitle: "Крафтові продукти",
        aboutImage: craftProduct1,
        aboutTitle: "Бринза зі спеціями в оливковій олії «Вогні Провансу» ТМ «Pastoral» 50% жирності в сухій речовині 550 g (г)",
        aboutStats: [
            "25,7 g (г)", "26,3 g (г)", "0 g (г)", "340 kcal (ккал)"
        ],
        aboutLink: "",
        aboutInformation: [
            {
                title: "Маса/Об'єм: ",
                desc: "550 g (г)",
            },
            {
                title: "Пакування: ",
                desc: "скло",
            },
            {
                title: "Склад: ",
                desc: "бринза (молоко незбиране, молоко знежирене, сіль харчова, консервант – калій азотнокислий, натуральний барвник аннато, гранулят хлориду кальцію, закваски мезофільних і термофільних бактерій, молокозсідальний фермент) – 54%; олія оливкова – 45%; спеції (томати сушені з часником та базиліком, паприка мелена копчена, паприка мелена, перець червоний мелений гострий, пекучий) – 1%.",
            },
            {
                title: "Термін придатності: ",
                desc: (
                    <>при температурі від 0ºС до 6ºС та відносній
вологості повітря від 80% до 85% включно – не більше 21 доби від дати фасування.</>
                ),

            },
            {
                title: "Сертифікат якості: ",
                desc: "ТУ У 15.5 – 05409745 – 002:2025.",
            },
        ],
        categoryInfo: [
            "Унікальні рецепти – ми відбираємо найкращі продукти зі світових молочних практик.",
            "Органолептичний тест – кожен новий продукт проходить дегустацію споживачами.",
            "Смаки, що запам’ятовуються – справжній гастрономічний досвід, до якого хочеться повертатися.",
    
        ],
    },
    {
        path: "/craft-products/brynza-herbs-olive-oil-alpiiski-travy-pastoral-50-fat-550g/",
        category: "craft",
        metaTitle: "Бринза з травами в оливковій олії «Альпійські трави»",
        metaDescription: "Бринза з травами в оливковій олії «Альпійські трави»",
        coverImage: craftProductsCoverImage,
        coverImageMobile: craftProductsCoverImageMobile,
        coverTitle: "Крафтові продукти",
        aboutImage: craftProduct2,
        aboutTitle: "Бринза з травами в оливковій олії «Альпійські трави» ТМ «Pastoral» 50% жирності в сухій речовині 550 g (г)",
        aboutStats: [
            "25,7 g (г)", "26,3 g (г)", "0 g (г)", "340 kcal (ккал)"
        ],
        aboutLink: "",
        aboutInformation: [
            {
                title: "Маса/Об'єм: ",
                desc: "550 g (г)",
            },
            {
                title: "Пакування: ",
                desc: "скло",
            },
            {
                title: "Склад: ",
                desc: "бринза (молоко незбиране, молоко знежирене, сіль харчова, консервант – калій азотнокислий, натуральний барвник аннато, гранулят хлориду кальцію, закваска мезофільних і термофільних бактерій, молокозсідальний фермент ) – 54%; олія оливкова – 45%; суміш трав «Прованська» – 1%.",
            },
            {
                title: "Термін придатності: ",
                desc: (
                    <>при температурі від 0ºС до 6ºС та відносній
вологості повітря від 80% до 85% включно – не більше 21 доби від дати фасування.</>
                ),

            },
            {
                title: "Сертифікат якості: ",
                desc: "ТУ У 15.5 – 05409745 – 002:2025.",
            },
        ],
        categoryInfo: [
            "Унікальні рецепти – ми відбираємо найкращі продукти зі світових молочних практик.",
            "Органолептичний тест – кожен новий продукт проходить дегустацію споживачами.",
            "Смаки, що запам’ятовуються – справжній гастрономічний досвід, до якого хочеться повертатися.",
    
        ],
    },
    {
        path: "/craft-products/brynza-spices-herbs-olive-oil-buket-provansu-pastoral-50-fat-550g/",
        category: "craft",
        metaTitle: "Бринза зі спеціями та травами в оливковій олії  «Букет Провансу»",
        metaDescription: "Бринза зі спеціями та травами в оливковій олії  «Букет Провансу»",
        coverImage: craftProductsCoverImage,
        coverImageMobile: craftProductsCoverImageMobile,
        coverTitle: "Крафтові продукти",
        aboutImage: craftProduct3,
        aboutTitle: "Бринза зі спеціями та травами в оливковій олії  «Букет Провансу» ТМ «Pastoral» 50% жирності в сухій речовині 550 g (г)",
        aboutStats: [
            "25,7 g (г)", "26,3 g (г)", "0 g (г)", "340 kcal (ккал)"
        ],
        aboutLink: "",
        aboutInformation: [
            {
                title: "Маса/Об'єм: ",
                desc: "550 g (г)",
            },
            {
                title: "Пакування: ",
                desc: "скло",
            },
            {
                title: "Склад: ",
                desc: "бринза (молоко незбиране, молоко знежирене, сіль харчова, консервант – калій азотнокислий, натуральний барвник аннато, гранулят хлориду кальцію, закваска мезофільних і термофільних бактерій, молокозсідальний фермент) – 54%; олія оливкова – 45%; спеції (томати сушені з часником та базиліком, паприка мелена копчена, паприка мелена), суміш трав «Прованська» – 1%.",
            },
            {
                title: "Термін придатності: ",
                desc: (
                    <>при температурі від 0ºС до 6ºС та відносній
вологості повітря від 80% до 85% включно – не більше 21 доби від дати фасування.</>
                ),

            },
            {
                title: "Сертифікат якості: ",
                desc: "ТУ У 15.5 – 05409745 – 002:2025.",
            },
        ],
        categoryInfo: [
            "Унікальні рецепти – ми відбираємо найкращі продукти зі світових молочних практик.",
            "Органолептичний тест – кожен новий продукт проходить дегустацію споживачами.",
            "Смаки, що запам’ятовуються – справжній гастрономічний досвід, до якого хочеться повертатися.",
    
        ],
    },
]